import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import {
  Outlet,
  Link,
} from "react-router-dom";

const { Sider } = Layout;

const PageLayout = ({ routes }) => {
  const [collapsed, setCollapsed] = useState(false);

  const onCollapse = collapsed => {
    setCollapsed(collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <div className="logo" />
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
          {routes.map(item => (
            <Menu.Item key={item.name} icon={item.icon}>
              <Link to={item.path}>{item.name}</Link>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Outlet />
    </Layout>
  );
}

export default PageLayout;